module.exports = __webpack_public_path__ + "static/img/solution-content2.8be77a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/solution-content2.png
// module id = bI2m
// module chunks = 0